import _ from "lodash";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { DateInput as SparkDateInput } from "react-spark";

import { withValidation } from "../hocs/WithValidation";
import {
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
} from "../hocs/prop-types";

class DateInput extends Component {
  componentDidMount() {
    this.props.context.registerFormElement({
      value: this.props.value,
      name: this.props.name,
      valid: this.props.validateOnRegisterUpdate.apply(this),
      validate: this.props.handleValidation
    });
  }

  componentDidUpdate() {
    if (this.props.forceUpdate) {
      this.props.context.updateFormElement({
        value: this.props.value,
        name: this.props.name,
        valid: this.props.validateOnRegisterUpdate.apply(this)
      });
    }
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  render() {
    const {
      className,
      context,
      disabled,
      errorMessage,
      handleBlur,
      handleChange,
      hideLabel,
      id,
      label,
      name,
      value,
      width
    } = this.props;

    return (
      <Fragment>
        <SparkDateInput
          className={className}
          disabled={disabled}
          error={errorMessage}
          id={id}
          label={hideLabel ? "" : label}
          name={name}
          onChange={event => handleChange(event, context)}
          onBlur={event => handleBlur(event, context.handleChange)}
          width={width}
          value={value}
        />
      </Fragment>
    );
  }
}

DateInput.defaultProps = {
  forceUpdate: false,
  handleBlur: () => {},
  handleChange: () => {},
};

DateInput.propTypes = {
  ...withValidationOutputPropTypes,
  ...sharedFormInputPropTypes,
  forceUpdate: PropTypes.bool,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleValidation: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  validation: PropTypes.shape({
    validateOn: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    validationRegex: PropTypes.regexp,
    checkValidity: PropTypes.func,
    message: PropTypes.shape({
      default: PropTypes.string,
      minlength: PropTypes.string,
      maxlength: PropTypes.string,
      pattern: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object
      ]),
      required: PropTypes.string
    })
  }).isRequired,
  value: PropTypes.string.isRequired
};

export default withValidation(DateInput);
